import { useState, useCallback } from 'react'
import api from '@/shared/lib/api'

interface ReviewInput {
  review_text: string
  rating: number
  business_name: string
  business_type: string
}

export function useAIReviewResponse() {
  const [response, setResponse] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [count, setCount] = useState(0)
  const [lastInput, setLastInput] = useState<ReviewInput | null>(null)

  const suggest = useCallback(async (input: ReviewInput) => {
    setIsLoading(true)
    setError(null)
    setLastInput(input)
    const tone = input.rating <= 2 ? 'professional' : input.rating >= 4 ? 'warm' : 'professional'
    try {
      const { data } = await api.post('/ai/review-response', { ...input, tone })
      setResponse(data.data.response)
      setCount((c) => c + 1)
    } catch (err: any) {
      setError(err?.response?.data?.detail || 'Erreur lors de la génération.')
    } finally {
      setIsLoading(false)
    }
  }, [])

  const regenerate = useCallback(async () => {
    if (!lastInput || count >= 3) return
    await suggest(lastInput)
  }, [lastInput, count, suggest])

  const reset = useCallback(() => {
    setResponse(null)
    setError(null)
    setCount(0)
    setLastInput(null)
  }, [])

  return { suggest, response, setResponse, isLoading, error, regenerate, count, reset }
}
